export default class AlphabeticalFilterController {
  constructor($stateParams) {
    'ngInject';

    this.$stateParams = $stateParams;
    this.letters = 'abcdefghijklmnopqrstuvwxyz'.split('');
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/members/screens/member-list/components/alphabetical-filter/alphabetical-filter.controller.js